"use client"

import { type Coupon } from '@prisma/client';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay, Navigation } from 'swiper/modules';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import DiscountCouponUI from './discount-coupon';

const CoupenSlider = ({ details }: {
    details: Coupon[];
}) => {
    return (
        <div className='relative max-w-sm w-full mx-auto'>
            <Swiper
                loop={true}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: true,
                    pauseOnMouseEnter: true
                }}
                navigation={{
                    prevEl: `.coupenPrev`,
                    nextEl: `.coupenNext`,
                }}
                modules={[Autoplay, Navigation]}
                className='mySwiper'
            >
                {details.map((data) => (
                    <SwiperSlide key={data.id}>
                        <DiscountCouponUI details={data} />
                    </SwiperSlide>
                ))}
            </Swiper>
            <button className='coupenPrev absolute z-20 top-1/2 -translate-y-1/2 left-0 -translate-x-1/2 size-7 rounded-full flex justify-center items-center bg-custom-primary text-white disabled:opacity-100 disabled:text-opacity-60 border-custom-primary'>
                <ArrowLeftIcon className="h-4 w-4" />
            </button>
            <button className='coupenNext absolute z-20 top-1/2 -translate-y-1/2 right-0 translate-x-1/2 size-7 rounded-full flex justify-center items-center bg-custom-primary text-white disabled:opacity-100 disabled:text-opacity-60 border-custom-primary'>
                <ArrowRightIcon className="h-4 w-4" />
            </button>
        </div>
    )
}

export default CoupenSlider